import axios from "axios";
import { isAuth } from "./auth";
import CryptoJS from 'crypto-js';

const user = isAuth()

const token = JSON.parse(localStorage.getItem("token"))
const header = { Authorization: `Bearer ${token}` }
export const notif = (data) => {
    axios.post('api/notification', data, { headers: header })
}
export const notif_read = (id, set) => {
    axios.put('api/notification/' + id, { read: set }, { headers: header })
}
export const formatDate = (dateString) => {
    const options = {
        // weekday: 'long', 
        year: 'numeric',
        month: 'long',
        day: '2-digit'
    };
    return new Date(dateString).toLocaleString("in-ID", options)
}


export const formatDate01 = (dateString) => {
    if (!dateString) {
        return '';
    }

    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
        return '';
    }

    let month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

export const formateDateTimeFull = (dateString) => {
    if (!dateString) {
        return '';
    }

    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
        return '';
    }

    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    };

    return date.toLocaleString('id-ID', options);
}

export const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })
}
export const saveHistory = (surat_id, status_id, text) => {
    const catatan = {
        user: user?.username,
        text: text
    }
    const history = {
        surat_id: surat_id,
        status_id: status_id,
        catatan: JSON.stringify(catatan)
    }
    axios.post('api/history', history, {
        headers: { Authorization: `Bearer ${token}` }
    })
}

export const encryptObject = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), 'thomi011045').toString()
}

export const encryptId = (id) => {

    if (id) {
        const encrypted = CryptoJS.AES.encrypt(id, 'thomi011045').toString();
        // throw new Error("Invalid ID for encryption");

        const result = encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        return result
    }
    // return false
    // Enkripsi menggunakan AES
    // Encode ke Base64 dan ganti karakter yang tidak diinginkan
};

export const decryptId = (encryptedId) => {
    if (!encryptedId) {
        throw new Error("Invalid encrypted ID for decryption");
    }
    // Decode dari Base64 dan ganti karakter yang telah dimodifikasi
    const decoded = encryptedId.replace(/-/g, '+').replace(/_/g, '/');
    // Dekripsi menggunakan AES
    const bytes = CryptoJS.AES.decrypt(decoded, 'thomi011045');
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
};
export const formatRupiah = (amount) => {
    return new Intl.NumberFormat().format(amount)
}